class UserActions {
    constructor() {
        this.Constants = {
            LoginSuccess: 'app/login/success',
            SaveUserData: 'app/save/user-data',
            sessionId: 'app/user/session-id',
            SessionRefresh: 'app/user/session/refresh',
            setSignupFormInfo: 'app/signup/user-forminfo-data',
            loaderMessage: 'app/loader/loader-message',
            helpMail: 'app/dashboard/helpemail',
            SELECTED_USER_LANG: 'SELECTED_USER_LANG',
            GENERIC_MARKETING_TEXT: 'GENERIC_MARKETING_TEXT',
            FIELD_CONFIG: 'app/dashboard/fieldConfig',
            selectedLocDetails: 'app/application/schedule',
            applicationDetails: '/app/application/details',
            impersonationDetails: 'app/impersonate/details',
            TourStatusUpdated: 'app/user/tour-status-updated'
        };
        this.loginSuccess = (data) => {
            return {
                type: this.Constants.LoginSuccess,
                payload: data
            };
        };
        this.setSessionId = (data) => {
            return {
                type: this.Constants.sessionId,
                payload: data
            };
        };
        this.sessionRefresh = (data) => {
            return {
                type: this.Constants.SessionRefresh,
                payload: data
            };
        };
        this.saveUserData = (data) => {
            return {
                type: this.Constants.SaveUserData,
                payload: data
            };
        };
        this.setSignupFormInfo = (data) => {
            return {
                type: this.Constants.setSignupFormInfo,
                payload: data
            };
        };
        this.setLoaderMessage = (data) => {
            return {
                type: this.Constants.loaderMessage,
                payload: data
            };
        };
        this.helpEmail = (data) => {
            return {
                type: this.Constants.helpMail,
                payload: data
            };
        };
        this.setSelectedLang = (data) => {
            return {
                type: this.Constants.SELECTED_USER_LANG,
                payload: data
            };
        };
        this.setGenericMarketingText = (data) => {
            return {
                type: this.Constants.GENERIC_MARKETING_TEXT,
                payload: data
            };
        };
        this.setFieldConfig = (data) => {
            return {
                type: this.Constants.FIELD_CONFIG,
                payload: data
            };
        };
        this.setSelectedLocDetails = (data) => {
            return {
                type: this.Constants.selectedLocDetails,
                payload: data
            };
        };
        this.setApplicationDetails = (data) => {
            return {
                type: this.Constants.applicationDetails,
                payload: data
            };
        };
        this.setImpersonationDetails = (data) => {
            return {
                type: this.Constants.impersonationDetails,
                payload: data
            };
        };
        this.setTourStatus = (data) => {
            return {
                type: this.Constants.TourStatusUpdated,
                payload: data
            };
        };
    }
}
export const user_actions = new UserActions();
